import { ITranslatableTextTask } from 'common/modules/ReactShared';
import { FC } from 'react';

import LearnTaskTemplate from '../common/LearnTaskTemplate';
import { ILearnTaskProps } from '../types';

const LearnTranslatableTextTask: FC<ILearnTaskProps<ITranslatableTextTask>> = ({
  task,
  onFinish,
  lightFont,
  isCompleting,
  previousTaskId
}) => {
  const {
    title,
    type,
    imageURL,
    imageAlt,
    mobileImageURL,
    coverImg,
    giphyImage,
    items: [
      {
        audioURL,
        content,
        translation,
        sourceLanguage: sourceLang,
        targetLanguage,
        fallbackTargetLanguageCode
      }
    ]
  } = task;

  return (
    <LearnTaskTemplate
      onFinish={onFinish}
      lightFont={lightFont}
      isCompleting={isCompleting}
      previousTaskId={previousTaskId}
      task={{
        title,
        audioURL,
        imageURL,
        imageAlt,
        mobileImageURL,
        coverImg,
        giphyImage,
        content,
        translation,
        sourceLanguage: sourceLang,
        targetLanguage,
        fallbackTargetLanguageCode,
        type
      }}
    />
  );
};

export default LearnTranslatableTextTask;
